import axios from "axios";
import { toast } from "react-toastify";
import authHeader from "./auth-header";

export const fetchAllUnits = (filters = {}) => {
  return new Promise((resolve, reject) => {
    const query_string = new URLSearchParams(filters).toString();
    
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/unit?${query_string}`, {
        headers: authHeader(),
      })
      .then((res) => {
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const fetchOneUnit = (id) => {
  return new Promise((resolve, reject) => {
    if (!id) return resolve(null);

    axios
      .get(`${process.env.REACT_APP_BASE_URL}/unit/${id}`, {
        headers: authHeader(),
      })
      .then((res) => {
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const createUnit = (data) => {
  return new Promise((resolve, reject) => {
    if (!data) return resolve(null);

    axios
      .post(`${process.env.REACT_APP_BASE_URL}/unit/`, data, {
        headers: authHeader(),
      })
      .then((res) => {
        toast.success(res.data.msg);
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const updateUnit = ({ id, data }) => {
  return new Promise((resolve, reject) => {
    if (!id || !data) return resolve(null);

    axios
      .put(`${process.env.REACT_APP_BASE_URL}/unit/${id}`, data, {
        headers: authHeader(),
      })
      .then((res) => {
        toast.success(res.data.msg);
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};

export const deleteUnit = (id) => {
  return new Promise((resolve, reject) => {
    if (!id) return resolve(null);

    axios
      .delete(`${process.env.REACT_APP_BASE_URL}/unit/${id}`, {
        headers: authHeader(),
      })
      .then((res) => {
        toast.success(res.data.msg);
        return resolve(res.data.data);
      })
      .catch((err) => {
        if (err?.response?.data?.msg) toast.error(err?.response?.data?.msg);
        return reject(err);
      });
  });
};
